function files(event) {
  return event.target.files
}

export default files
